import React, { useState } from 'react';
import { X } from 'lucide-react';
import { NewTicket } from './NewTicket';
import { TicketList } from './TicketList';
import { useAuth } from '../../lib/AuthContext';

interface TicketModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TicketModal({ isOpen, onClose }: TicketModalProps) {
  const [showNewTicket, setShowNewTicket] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const { user } = useAuth();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-900">Support</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6">
          {!user ? (
            <div className="text-center py-12">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Sign in Required</h3>
              <p className="text-gray-500 mb-6">
                Please sign in to use our support ticketing system.
              </p>
              <button
                onClick={onClose}
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
              >
                Close
              </button>
            </div>
          ) : showNewTicket ? (
            <div>
              <button
                onClick={() => setShowNewTicket(false)}
                className="mb-4 text-gray-600 hover:text-gray-900 flex items-center"
              >
                <span className="mr-2">←</span> Back to Tickets
              </button>
              <NewTicket
                onSubmit={() => {
                  setShowNewTicket(false);
                  setRefreshKey(prev => prev + 1);
                }}
                onCancel={() => setShowNewTicket(false)}
              />
            </div>
          ) : (
            <TicketList 
              onNewTicket={() => setShowNewTicket(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
}